import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private storage: Storage, private router: Router) {}

  async canActivate(): Promise<boolean> {
    // Check if the secure JWT token exists in Ionic Storage
    const token = await this.storage.get('auth_token');
    
    if (token) {
      // Token exists, allow them to access the page
      return true;
    } else {
      // No token found! Kick them back to the login page
      this.router.navigate(['/signin']); // Change '/login' if your login route is named differently (e.g., '')
      return false;
    }
  }
}